import { ChangeDetectionStrategy, Component, Signal, computed, inject } from '@angular/core';
import { FLOATING_PANEL_DATA } from '@shared/floating-panel/floating-panel-data.token';
import { HdFixedStarSkyChartComponent } from './hd-fixed-star-sky-chart.component';

/** Data waarmee het vergrote-kaart-paneel geopend wordt. */
export interface HdFixedStarSkyChartPanelData {
  readonly side: number;
}

/**
 * Vergrote weergave van de fixed-star-sterrenkaart, geopend als los
 * floating/docked paneel (hergebruikt het bestaande paneelsysteem, geen aparte
 * dialoglaag). Krijgt het side-nummer via {@link FLOATING_PANEL_DATA}.
 */
@Component({
  selector: 'hd-fixed-star-sky-chart-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HdFixedStarSkyChartComponent],
  template: `
    <section class="sky-chart-panel">
      <hd-fixed-star-sky-chart [side]="side()" variant="large" />
    </section>
  `,
  styles: `
    .sky-chart-panel {
      padding: 12px;
      /* Expliciete breedte (geen max-width): zo krijgt het zwevende paneel een
         grote afmeting i.p.v. te krimpen tot een mini-dialog. */
      width: min(880px, 92vw);
    }
  `,
})
export class HdFixedStarSkyChartPanelComponent {
  private readonly panelData = inject(FLOATING_PANEL_DATA, { optional: true }) as
    | Signal<HdFixedStarSkyChartPanelData>
    | null;

  protected readonly side = computed(() => this.panelData?.()?.side ?? 1);
}
